import { UploadOutlined } from '@ant-design/icons'
import { Button } from 'antd'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { LocalFileFragment } from '@/generated/graphql'
import { PostEditorFiles } from '@/modules/post/post-editor/post-editor-files.component'

import { useFileUpload } from './file-upload.hooks'
import { emptyFileState } from './file-upload.state'

export const FileUploadButton: React.FC<{
  name: string
  isDone: boolean
  currentFiles?: LocalFileFragment[]
  showFiles?: boolean
  setFileIds?: React.Dispatch<React.SetStateAction<number[]>>
  setFiles?: React.Dispatch<React.SetStateAction<LocalFileFragment[]>>
  onStart?: (file?: LocalFileFragment | null) => void
  onProgress?: (file?: LocalFileFragment | null) => void
  onComplete?: (file?: LocalFileFragment | null) => void
  onError?: (file?: LocalFileFragment | null) => void
  onValidation?: (file: File) => { errorInfo: string; errorMessage: string }
  onMouseEnter?: any
  onMouseLeave?: any
  onFocus?: any
  onClick?: any
  props?: any
}> = ({
  name,
  isDone,
  currentFiles,
  setFileIds,
  setFiles,
  onStart,
  onProgress,
  onComplete,
  onError,
  onValidation,
  showFiles = true,
  onMouseEnter,
  onMouseLeave,
  onFocus,
  onClick,
  children,
  props,
}) => {
  const { t } = useTranslation()
  const { state, setState, uploadClickRef } = useFileUpload({
    name,
    currentFiles,
    onStart,
    onProgress,
    onComplete,
    onError,
    onValidation,
  })
  const tooltipProps = { onMouseEnter, onMouseLeave, onFocus, onClick }

  React.useEffect(() => {
    setState((state: any) => ({ ...emptyFileState, ...state }))
    setFileIds && setFileIds(state.files.map((file: LocalFileFragment) => file.fileId))
    setFiles && setFiles(state.files.slice())
  }, [])

  React.useEffect(() => {
    setFileIds && setFileIds(state.files.map((file: LocalFileFragment) => file.fileId))
    setFiles && setFiles(state.files.slice())
  }, [state])

  React.useEffect(() => {
    if (isDone) {
      setState(() => ({ ...emptyFileState }))
    }
    return () => setState(() => ({ ...emptyFileState }))
  }, [isDone])

  const component = children ? (
    React.cloneElement(children as any, {
      ...tooltipProps,
      ...props,
      ref: uploadClickRef,
    })
  ) : (
    <div style={{ padding: '16px 0' }}>
      <Button type='primary' icon={<UploadOutlined />} ref={uploadClickRef} style={{ width: '100%' }}>
        {t('post.editor.upload')}
      </Button>
      {showFiles && (
        <div style={{ paddingTop: 16 }}>
          <PostEditorFiles files={state.files} setState={setState} />
        </div>
      )}
    </div>
  )

  return component
}
